import * as React from 'react'

import { TextBody, Button, Space } from '@ally/metronome-ui'
import { InformationScreenType } from '@ally/transmitigator'
import { LoginHeading } from '@ally/ally-login'

import { useTransmit } from '../../TransmitContext'

export const SecurityWelcome: React.FC = () => {
  const { activeScreen, hostServices } = useTransmit()

  React.useEffect(() => {
    if (activeScreen.type === InformationScreenType.SetupWelcome) {
      hostServices?.analytics.trackPageView({
        eventType: 'pageview',
        pageName: 'AOS:Login:Security',
      })
    }
  }, [activeScreen.type])

  if (activeScreen.type !== InformationScreenType.SetupWelcome) {
    return null
  }

  return (
    <>
      <LoginHeading title="Welcome to Ally Online" />
      <Space my={1}>
        <TextBody size="sm" tag="p">
          At Ally, we want to make sure your account information is safe and
          secure.
        </TextBody>
      </Space>
      <Space mt={1} mb={5}>
        <TextBody size="sm" tag="p">
          Before you can access your accounts online, please set up additional
          security features.
        </TextBody>
      </Space>
      <Button
        text="Set Up Security"
        type="button"
        onClick={activeScreen.payload.onComplete}
        loading={activeScreen.payload.status === 'Loading'}
        variant="primary"
      />
    </>
  )
}
